export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/guitar.15c2bdf.svg";